import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto py-4">
      <h1 className="font-archivoblack text-5xl font-bold mb-6 text-left text-[#34375B]">{t("faq.title")}</h1>

      <Accordion type="single" collapsible className="w-full text-left">
        <AccordionItem value="item-1">
          <AccordionTrigger className="text-[#34375B] text-xl font-bold">{t("faq.questions.createInvoice.question")}</AccordionTrigger>
          <AccordionContent className="font-normal text-lg text-[#34375B]/70">
            {t("faq.questions.createInvoice.answer")}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-2">
          <AccordionTrigger className="text-[#34375B] text-xl font-bold">{t("faq.questions.recurring.question")}</AccordionTrigger>
          <AccordionContent className="font-normal text-lg text-[#34375B]/70">
            {t("faq.questions.recurring.answer")}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-3">
          <AccordionTrigger className="text-[#34375B] text-xl font-bold">{t("faq.questions.profile.question")}</AccordionTrigger>
          <AccordionContent className="font-normal text-lg text-[#34375B]/70">
            {t("faq.questions.profile.answer")}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-4">
          <AccordionTrigger className="text-[#34375B] text-xl font-bold">{t("faq.questions.payment.question")}</AccordionTrigger>
          <AccordionContent className="font-normal text-lg text-[#34375B]/70">
            {t("faq.questions.payment.answer")}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-5">
          <AccordionTrigger className="text-[#34375B] text-xl font-bold">{t("faq.questions.security.question")}</AccordionTrigger>
          <AccordionContent className="font-normal text-lg text-[#34375B]/70">
            {t("faq.questions.security.answer")}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default FAQ;